import angular from 'angular'
import template from './template.html'

export class NominasNominaTimbresComponent {
  seleccionados = []

  constructor($http, NominasNominaTimbres, NominaTimbresTimbreEstatusTimbrado, NominaTimbresTimbreEstatusCancelado) {
    this.$http = $http
    this.NominasNominaTimbresService = NominasNominaTimbres
    this.NominaTimbresTimbreEstatusTimbradoService = NominaTimbresTimbreEstatusTimbrado
    this.NominaTimbresTimbreEstatusCanceladoService = NominaTimbresTimbreEstatusCancelado
  }

  $onInit () {
    this.$promise = this.$http.get('/api/nominas/timbrado/empresas/empresa/nomina', {
      params: { idEmpresa: this.idProyecto, idNomina: this.idNomina },
      schema: {
        fecha: 'date',
        fecha_pago: 'date',
        status_timbrado: 'boolean',
        status_pagado: 'boolean',
      },
    }).then((response) => {
      this.data = response.data
      this.valido = this.data.serie
        && this.data.cliente
        && this.data.cliente_rfc
        && this.data.pagadora

      if (this.valido) {
        return this.NominasNominaTimbresService.get(this.idProyecto, this.idNomina)
          .then((response) => {
            this.data.timbres = response.data
            this.data.timbres.forEach((item) => (item.retenido = false))
          })
      }
    })

  }

  actualizar () {
    this.data.timbres = [].concat(this.data.timbres)
  }

  cancelar (timbres, data) {
    if (timbres && angular.isArray(timbres)) {
      timbres.forEach((item) => {
        item.pendiente = true

        return this.NominaTimbresTimbreEstatusCanceladoService.put(item.id_nomina, item.id_empresa, item.id_empleado, item.indice, data)
          .then((response) => {
            item.timbrado_error = null
            angular.extend(item, response.data)
          })
          .catch((response) => {
            item.timbrado_error = response.data
          })
          .finally(() => {
            item.pendiente = false

            this.actualizar()
          })
      })

      this.deseleccionar()
    }
  }

  consultar (timbres) {
    if (timbres && angular.isArray(timbres)) {
      timbres.forEach((item) => {
        item.pendiente = true
        item.timbrado_error = null

        return this.NominaTimbresTimbreEstatusCanceladoService.get(item.id_nomina, item.id_empresa, item.id_empleado, item.indice)
          .then((response) => {
            item.timbrado_error = null
            angular.extend(item, response.data)
          })
          .catch((response) => {
            item.timbrado_error = response.data
          })
          .finally(() => {
            item.pendiente = false

            this.actualizar()
          })
      })

      this.deseleccionar()
    }
  }

  timbrar (timbres, data) {
    if (timbres && angular.isArray(timbres)) {
      timbres.forEach((item) => {
        item.timbrado_error = null
        item.pendiente = true

        return this.NominaTimbresTimbreEstatusTimbradoService.put(item.id_nomina, item.id_empresa, item.id_empleado, item.indice, data)
          .then((response) => {
            item.timbrado_error = null
            angular.extend(item, response.data)
          })
          .catch((response) => {
            item.timbrado_error = response.data
          })
          .finally(() => {
            item.pendiente = false
            this.actualizar()
          })
      })

      this.deseleccionar()
    }
  }

  deseleccionar () {
    this.data.timbres = this.data.timbres.map((item) => {
      item.$$seleccionado = false

      return item
    })
  }

  generarXml (data) {
    data.forEach((item) => {
      item.xml_generado = true
    })

    this.deseleccionar()
  }
}

angular.module('nominas.nomina')
  .component('nominasNominaTimbres', {
    template: template,
    controller: NominasNominaTimbresComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/component.js